// @ts-nocheck
import React, { useEffect, useState } from 'react';

import { ContentSteps, HeaderSteps, TitleSteps, ContentProposal, ActionSignProposal } from '../styles';

// CONTEXT
import { useRetentionSignature } from '../../../../hooks/RetentionSignatureContext';

// SERVICE
import SignatureService from '../../../../services/SignatureService';

//SVG
import { ArrowLeft } from '../../Form/svgs';

// COMPONENTS
import { ProposalConsigRetention } from '../../Proposal';
import { Button } from '../../../../components/UISignatue/Button';
import { Loader } from '../../../../components/UISignatue/Loader';

import { ArrowRight } from '../svgs';
import Signature from '../../../../interfaces/Signature';
import logger from '../../../../utils/logger.utils';

interface IProposaList {
  formValues: Signature;
}

export const ProposaListRetention = ({ formValues }: IProposaList) => {
  const { formOpened, setFormOpened, setStep, nextStep, setErrorSignature } = useRetentionSignature();
  const [data, setData] = useState<any | null>([]);
  const [fetchloading, setFetchLoading] = useState(false);

  const handleListProposal = async () => {
    try {
      setFetchLoading(true);
      const proposalResponse = await SignatureService.fetchProposalRetention(formOpened.token);
      setData(proposalResponse.data);
    } catch (error) {
      logger.error('Error handling list proposal: ', error);
    } finally {
      setFetchLoading(false);
    }
  };

  const handleSignedProposalConsig = (e: any) => {
    // Get all proposal numbers and store them
    const allProposalNumbers = data.map((proposal: { proposalNumber: string | number }) => proposal.proposalNumber);

    // Store proposal data for the next step
    const proposalsData = data.map((proposal: { proposalNumber: string | number; terms: string[] }) => ({
      proposalNumber: proposal.proposalNumber,
      terms: proposal.terms || [],
    }));

    // Update formOpened with proposals data
    setFormOpened({
      ...formOpened,
      proposals: allProposalNumbers,
      proposalsData: proposalsData, // Store complete proposal data for next step
    });

    // Advance to next step (RetentionReason)
    nextStep(e);
  };

  const handlePrevstep = () => {
    setStep((previousStep: any) => previousStep - 1);
  };

  useEffect(() => {
    handleListProposal();
  }, []);

  return (
    <ContentSteps>
      <HeaderSteps>
        <button onClick={handlePrevstep}>
          <ArrowLeft />
        </button>
        <TitleSteps>Minhas propostas</TitleSteps>
      </HeaderSteps>

      <ContentProposal>
        {fetchloading ? (
          <>
            <Loader black title="Carregando propostas" />
          </>
        ) : (
          <>
            {data.map((item: any, id: any) => {
              return <ProposalConsigRetention formValues={item} key={id} />;
            })}
          </>
        )}
      </ContentProposal>

      <ActionSignProposal>
        <Button black big spaced onClick={handleSignedProposalConsig} iconRight={ArrowRight} disabled={fetchloading}>
          Assinar propostas ({data.length} de {data.length})
        </Button>
      </ActionSignProposal>
    </ContentSteps>
  );
};
